<ng-container [ngSwitch]="item.type">

  <app-global-search-list
    *ngSwitchCase="blockTypeEnum.GLOBAL_SEARCH_RESULTS_LIST_TYPE"
    [specialBlock]="item"
  ></app-global-search-list>

  <app-inventory-list
    *ngSwitchCase="blockTypeEnum.INVENTORIES_LIST_TYPE_WWW"
    [specialBlock]="item"
  ></app-inventory-list>

  <app-list-filters *ngSwitchCase="blockTypeEnum.INVENTORY_FILTERS_TYPE" [specialBlock]="item"></app-list-filters>

  <div *ngSwitchCase="blockTypeEnum.SORTING_LIST_TYPE" style="height: auto; position: relative;">
    <app-sorting-list *ngIf="isChild()" class="sortList" [keyBlock]="item.uId" [specialBlock]="item"></app-sorting-list>
  </div>

  <div
    app-block-container
    *ngSwitchCase="blockTypeEnum.UNIVERSAL_TYPE"
    [children]="item.children"
  ></div>

  <app-slider
    *ngSwitchCase="blockTypeEnum.SLIDER_TYPE"
    [specialBlock]="item">
  </app-slider>

  <my-account-dropdown
    *ngSwitchCase="blockTypeEnum.MY_ACCOUNT_DROPDOWN_TYPE"
    [specialBlock]="item">
  </my-account-dropdown>

  <shopping-cart
    *ngSwitchCase="blockTypeEnum.BASKET_ICON_TYPE"
    [specialBlock]="item">
  </shopping-cart>

  <app-list-filters
    *ngSwitchCase="blockTypeEnum.NEWS_FILTERS_TYPE"
    [specialBlock]="item"
  ></app-list-filters>

  <app-list-filters
    *ngSwitchCase="blockTypeEnum.ARTISTS_FILTERS_TYPE"
    [specialBlock]="item"
  ></app-list-filters>

  <app-list-filters
    *ngSwitchCase="blockTypeEnum.EXHIBITIONS_FILTERS_TYPE"
    [specialBlock]="item"
  ></app-list-filters>

  <language-switcher
    *ngSwitchCase="blockTypeEnum.LANGUAGE_SWITCH_TYPE"
    [specialBlock]="item">
  </language-switcher>

  <currency-switcher
    *ngSwitchCase="blockTypeEnum.CURRENCY_CHANGE_DROPDOWN_TYPE"
    [specialBlock]="item">
  </currency-switcher>

  <app-exhibition-list
    *ngSwitchCase="blockTypeEnum.EXHIBITIONS_LIST_TYPE"
    [specialBlock]="item"
  ></app-exhibition-list>

  <app-news-list
    *ngSwitchCase="blockTypeEnum.NEWS_LIST_TYPE"
    [specialBlock]="item"
  ></app-news-list>

  <app-lightbox
    *ngSwitchCase="blockTypeEnum.LIGHTBOX_TYPE"
    [specialBlock]="item">
  </app-lightbox>

  <app-lightbox
    *ngSwitchCase="blockTypeEnum.LIGHTBOX_CMS_TYPE"
    [specialBlock]="item">
  </app-lightbox>

  <app-contact-form
    *ngSwitchCase="blockTypeEnum.CONTACT_FORM_TYPE"
    [class]="item.uId"
    [specialBlock]="item">
  </app-contact-form>

  <app-contact-form
    *ngSwitchCase="blockTypeEnum.CONTACT_FORM_FOR_ARTWORK_TYPE"
    [class]="item.uId"
    [specialBlock]="item">
  </app-contact-form>

  <div
    *ngSwitchCase="blockTypeEnum.BUTTON_TYPE"
    [block]="item"
    app-button
  ></div>

  <app-artist-list
    *ngSwitchCase="blockTypeEnum.ARTISTS_LIST_TYPE_WWW"
    [specialBlock]="item"
  ></app-artist-list>

  <app-paginator-view
    *ngSwitchCase="blockTypeEnum.PAGINATION_TYPE"
    [specialBlock]="item"
  ></app-paginator-view>

  <app-register-form
    *ngSwitchCase="blockTypeEnum.REGISTER_TYPE"
    [class]="item.uId"
    [specialBlock]="item">
  </app-register-form>

  <app-login-form
    *ngSwitchCase="blockTypeEnum.LOGIN_TYPE"
    [class]="item.uId"
    [specialBlock]="item">
  </app-login-form>

  <app-password-reset-form
    *ngSwitchCase="blockTypeEnum.PASSWORD_RESET_TYPE"
    [class]="item.uId"
    [specialBlock]="item">
  </app-password-reset-form>

  <app-filter-search-input
    *ngSwitchCase="blockTypeEnum.FILTER_SEARCH_INPUT_TYPE"
    [block]="item"
  ></app-filter-search-input>
  <app-filter-group-selector
    *ngSwitchCase="blockTypeEnum.FILTER_GROUP_SELECTOR_TYPE"
    [block]="item"
    [expanded]="expanded"
    [extraData]="extraData">
  </app-filter-group-selector>


  <app-filter-single-selector
    *ngSwitchCase="blockTypeEnum.FILTER_SINGLE_SELECTOR_TYPE"
    [block]="item">
  </app-filter-single-selector>
  <app-filter-slidable
    *ngSwitchCase="blockTypeEnum.SLIDER_PRICE_RANGE_TYPE"
    [blockType]="blockTypeEnum.SLIDER_PRICE_RANGE_TYPE"
    [item]="item">
  </app-filter-slidable>

  <app-filter-slidable
    *ngSwitchCase="blockTypeEnum.SLIDER_YEAR_OF_CREATION"
    [blockType]="blockTypeEnum.SLIDER_YEAR_OF_CREATION"
    [item]="item">
  </app-filter-slidable>

  <app-global-search-input
    *ngSwitchCase="blockTypeEnum.GLOBAL_SEARCH_INPUT_TYPE"
    [block]="item"
  ></app-global-search-input>

  <app-artwork-request-form
    *ngSwitchCase="blockTypeEnum.ARTWORK_REQUEST_FORM"
    [specialBlock]="item"
  ></app-artwork-request-form>

  <app-advanced-filters
    *ngSwitchCase="blockTypeEnum.INVENTORY_ADVANCED_FILTERS_TYPE"
    [specialBlock]="item"
  ></app-advanced-filters>

  <app-advanced-filter-group-selector
    *ngSwitchCase="blockTypeEnum.ADVANCED_FILTER_GROUP_SELECTOR_TYPE"
    [block]="item">
  </app-advanced-filter-group-selector>

  <app-active-filter-preview
    *ngSwitchCase="blockTypeEnum.ACTIVE_FILTERS_PREVIEW_TYPE"
    [block]="item">
  </app-active-filter-preview>

  <app-filter-range
    *ngSwitchCase="blockTypeEnum.RANGE_PRICE_OF_CREATION"
    [item]="item">
  </app-filter-range>

  <app-filter-range
    *ngSwitchCase="blockTypeEnum.RANGE_YEAR_OF_CREATION"
    [item]="item">
  </app-filter-range>

  <ng-container *ngSwitchCase="blockTypeEnum.PRICE_CONFIGURATOR_TYPE">
    <app-price-configurator
      *appHasFeature="'inwentarz-edycje'"
      [specialBlock]="item">
    </app-price-configurator>
  </ng-container>
</ng-container>
